// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"3":"d8742129","508":"2412a2b0","796":"63648bbf","908":"6659ea12"}[chunkId] + ".css";
};